module.exports = __webpack_public_path__ + "img/bookmarks.1cc71c6f.jpg";